import React from 'react';
import { Ambient } from '../Ambient';
import { PartnershipLockup, VexuLockup } from '../Brand';
import { Hairline, Reveal } from '../Reveal';
export function CoverSlide() {
  return <section className="relative h-full w-full" data-id="element-615" data-mp="k8s7k63zu2l4">
      <Ambient variant="cover" data-id="element-616" data-mp="k7h3s6ajsuu0" />

      <div className="relative flex h-full flex-col px-[110px] pb-[76px] pt-[72px]" data-id="element-617" data-mp="k6pbb4c8zd7y">
        <Reveal delay={0} data-id="element-618" data-mp="f7w4furgukgr">
          <VexuLockup size={38} wordmarkSize={24} data-id="element-619" data-mp="b83v3fu90aac" />
        </Reveal>

        <div className="flex flex-1 flex-col justify-center" data-id="element-620" data-mp="b6amhv02rfzp">
          <Reveal delay={0.08} data-id="element-621" data-mp="6895rgq4fsre">
            <span className="block text-[12px] font-semibold uppercase tracking-[0.34em] text-vexu-600" data-id="element-622" data-mp="6bddup6pj8nc">
              Executive Briefing
            </span>
          </Reveal>

          <Reveal delay={0.16} y={20} data-id="element-623" data-mp="3shsd8sqhsu2a">
            <h1 className="mt-[30px] max-w-[1180px] text-[92px] font-semibold leading-[0.98] tracking-[-0.035em] text-slate-900" data-id="element-624" data-mp="1vo8i16p1dyb9">
              The AI Conversational
              <br data-id="element-625" data-mp="1qpnjrctchopg" />
              Layer for Telecom
            </h1>
          </Reveal>

          <Reveal delay={0.26} data-id="element-626" data-mp="3pdsimcpo8dh9">
            <p className="mt-[34px] text-[23px] font-light leading-relaxed tracking-[-0.01em] text-slate-500" data-id="element-627" data-mp="3pgy65ninj7av">
              One AI Technology Stack.{' '}
              <span className="font-normal text-slate-800" data-id="element-628" data-mp="3fhh1n9f4yzgh">
                Multiple Telecom-Ready Experiences.
              </span>
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.36} data-id="element-629" data-mp="bz5ng24bh4yg">
          <Hairline data-id="element-630" data-mp="c078mzf1r7tw" />
          <div className="flex items-end justify-between pt-[30px]" data-id="element-631" data-mp="c1s36p1d2qrr">
            <PartnershipLockup vexuSize={32} vexuWordmarkSize={20} zainHeight={27} data-id="element-632" data-mp="gxgvq8eyr7ek" />
            <span className="pb-[3px] text-[12px] font-medium uppercase tracking-[0.24em] text-slate-400" data-id="element-633" data-mp="281gnposoqep">
              Strategic Technology Partnership
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}